import { render } from "./EmployeeDocumentsView.vue?vue&type=template&id=5edbca2c&scoped=true"
import script from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"
export * from "./EmployeeDocumentsView.vue?vue&type=script&lang=js"

import "./EmployeeDocumentsView.vue?vue&type=style&index=0&id=5edbca2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5edbca2c"]])

export default __exports__